import React, { useEffect, useState } from 'react';
import { Modal, Button } from 'antd';

// Flags en sessionStorage:
// - lti_auto_logout: '1' indica sesión iniciada vía LTI (ver src/App.js).
// - lti_welcome_shown: '1' evita repetir el modal dentro del mismo launch.
//   LtiSso limpia este flag al iniciar cada launch LTI, así el modal reaparece en
//   cada entrada desde Blackboard, pero no en cada navegación interna.
const LTI_SESSION_FLAG = 'lti_auto_logout';
const WELCOME_SHOWN_FLAG = 'lti_welcome_shown';

/**
 * Modal de bienvenida que se muestra una vez por launch LTI.
 * El contexto inválido (context.label sin formato válido) NO llega aquí: LtiSso
 * redirige a /auth/lti-curso-invalido antes de entrar a la app.
 */
const LtiWelcomeModal = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const isLti = sessionStorage.getItem(LTI_SESSION_FLAG) === '1';
    if (!isLti) return;
    if (sessionStorage.getItem(WELCOME_SHOWN_FLAG) === '1') return;
    setOpen(true);
  }, []);

  const handleAccept = () => {
    sessionStorage.setItem(WELCOME_SHOWN_FLAG, '1');
    setOpen(false);
  };

  return (
    <Modal
      title="¡Bienvenido/a a la Plataforma de Simulación Logística!"
      open={open}
      closable={false}
      maskClosable={false}
      keyboard={false}
      footer={[
        <Button key="accept" type="primary" onClick={handleAccept}>
          Aceptar
        </Button>,
      ]}
    >
      <p>
        Aquí podrás aplicar y fortalecer tus conocimientos en gestión logística a través de
        escenarios interactivos y realistas, cerrando la brecha entre la teoría y la práctica.
        Toma decisiones estratégicas, gestiona cadenas de suministro y desarrolla tus
        competencias en un entorno seguro y desafiante.
      </p>
      <p style={{ marginBottom: 0 }}>
        ¡Explora, experimenta y lleva tu aprendizaje al siguiente nivel!
      </p>
    </Modal>
  );
};

export default LtiWelcomeModal;
